import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box, InputLabel } from '@material-ui/core';
import { useStyles } from './styles';
import { Tests } from '../../@types/records';
import SubInputWarn from '../SubInputWarn';

interface IProps {
  testsAmount: Tests;
  setTestsAmount: React.Dispatch<SetStateAction<Tests>>;
  formErrors: { key: string; message: string }[];
}

const TestsPeformedFormGroup: React.FC<IProps> = ({
  testsAmount,
  setTestsAmount,
  formErrors,
}) => {
  const classes = useStyles();
  const [testsState, setTestsState] = useState<Tests>(testsAmount);
  const [errors, setErrors] = useState<{ key: string; message: string }[]>([]);

  const handleChange = (key: string, value: string) => {
    setTestsState({ ...testsAmount, [key]: value });
  };

  useEffect(() => {
    setTestsState(testsAmount);
    const mapErrors = formErrors.filter((item) => {
      return item.key === 'testsRefusal' || item.key === 'testsPositive';
    });

    setErrors(mapErrors);
  }, [formErrors, testsAmount]);

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Quantidade de Testes Realizados ou Iniciados</Typography>
      <Grid container xl={12} spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Testes realizados por etilômetro passivo
          </InputLabel>
          <input
            name="Descrição do Tipo da Missão"
            type="number"
            min={0}
            className={`${classes.input} ${errors.length ? classes.errorIput : ''}`}
            value={testsState.Passivos}
            onChange={(event) => {
              handleChange('Passivos', event.target.value);
            }}
            onBlur={() => setTestsAmount(testsState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => {
              return item.key === 'testsRefusal' || item.key === 'testsPositive';
            })}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Testes realizados por Alcoolsensor
          </InputLabel>
          <input
            name="Alcoolsensor"
            type="number"
            min={0}
            className={`${classes.input} ${errors.length ? classes.errorIput : ''}`}
            value={testsState.Alcoolsensor}
            onChange={(event) => {
              handleChange('Alcoolsensor', event.target.value);
            }}
            onBlur={() => setTestsAmount(testsState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => {
              return item.key === 'testsRefusal' || item.key === 'testsPositive';
            })}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TestsPeformedFormGroup;
